import { render, staticRenderFns } from "./Footer-component.vue?vue&type=template&id=17df02e4&scoped=true"
import script from "./Footer-component.vue?vue&type=script&lang=js"
export * from "./Footer-component.vue?vue&type=script&lang=js"
import style0 from "./Footer-component.vue?vue&type=style&index=0&id=17df02e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df02e4",
  null
  
)

export default component.exports